module.exports = __webpack_public_path__ + "img/north-star-logo.cc655b7d.png";